<template>
  <b-row>
    <b-col cols="12" lg="12">
      <p v-if="loading" style="text-align: center;padding: 20px">
        <span style="font-size: 25px;">
            <i class="fa fa-spinner fa-spin"></i> Loading...
        </span>
      </p>
      <div v-else>
        <b-card header=""> 
          <b-row>
          <b-col lg="9" md="9" sm="12" xs="12">
            <b-card header="Role and Permission settings">
              <form @submit.prevent="updateRoleDetails">
              
              </form>
            </b-card>
          </b-col>
          </b-row>
          <template slot="footer">
            <b-button @click="goBack">Back</b-button>
          </template>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { baseURL } from '@/shared/utils'

export default {
  name: 'User',
  data: () => {
    return {
      role_details: {},
      loading: false,
      roles: [],
      permissions: [],
      isLoading: false,
    }
  },
  created() {
    this.getRoleDetails();
  },
  methods: {
    getRoleDetails() {
      this.loading = true;
      const role_id = this.$route.params.id
      this.$http.get(`${baseURL}role/${role_id}`)
      .then(({data}) => {
        this.loading = false;
        this.role_details = data.role;
        this.permissions = data.role.permissions;
      })
      .catch((error) => {
        this.loading = false;
      });
    },
    updateRoleDetails() {
      const user_id = this.$route.params.id;
      this.isLoading = true;
      this.$http.post(`${baseURL}user/${user_id}`, {
        first_name: this.user_details.first_name,
        last_name: this.user_details.last_name,
        email: this.user_details.email,
        roles: this.role,
        telephone: this.user_details.telephone
      })
      .then(({data}) => {
        this.user_details = data.user;
        this.isLoading = false;
        this.$swal('Updated Successfully', 'User profile updated successfully.', 'success');
      })
      .catch((error) => {
        this.isLoading = false;
        this.$swal('Error!', 'Something went wrong', 'error');
      })
    },
    changePassword() {

    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
